"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeGradientBackground = exports.BLANK_BACKGROUND = exports.COLOUR_MAPPINGS = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _colors = require("HubStyleTokens/colors");

var _useOptions = require("./useOptions");

var _COLOUR_MAPPINGS;

var COLOUR_MAPPINGS = (_COLOUR_MAPPINGS = {}, (0, _defineProperty2.default)(_COLOUR_MAPPINGS, _useOptions.DEFAULT, {
  primary: _colors.GYPSUM,
  secondary: _colors.KOALA
}), (0, _defineProperty2.default)(_COLOUR_MAPPINGS, _useOptions.SHADE, {
  primary: _colors.KOALA,
  secondary: _colors.GYPSUM
}), (0, _defineProperty2.default)(_COLOUR_MAPPINGS, _useOptions.DARK, {
  primary: _colors.HEFFALUMP,
  secondary: _colors.SLINKY
}), _COLOUR_MAPPINGS);
exports.COLOUR_MAPPINGS = COLOUR_MAPPINGS;
var BLANK_BACKGROUND = "\n  background: " + _colors.OLAF + ";\n";
exports.BLANK_BACKGROUND = BLANK_BACKGROUND;

var makeGradientBackground = function makeGradientBackground(_ref) {
  var primary = _ref.primary,
      secondary = _ref.secondary;
  return "\n  background: " + primary + ";\n  background: linear-gradient(to right, " + primary + ", " + secondary + " 20%, " + primary + " 40%);\n  background-size: 1200px;\n";
};

exports.makeGradientBackground = makeGradientBackground;